import routesLimited from '@/constants/routesLimited'
import type { RouteRecordRaw } from 'vue-router'

export const buildingPropertyManager: RouteRecordRaw = {
	component: () =>
		import(
			'components/templates/Datatable/Selected/BuildingPropertyManager.vue'
		),
	meta: {
		title: 'Manage Property Manager',
		auth: true,
		limited: routesLimited.can_update,
	},
	name: 'buildingPropertyManager',
	path: '/buildings/property-manager',
	props: true,
}

export const buildingExport: RouteRecordRaw = {
	component: () =>
		import('components/templates/Datatable/Selected/BuildingExport.vue'),
	meta: {
		title: 'Export Buildings',
		auth: true,
		limited: routesLimited.can_update,
	},
	name: 'buildingExport',
	path: '/buildings/export',
	props: true,
}

